import api from '@utils/api';

export const getVehicles = async (params) => {
  try {
    const response = await api.get('/electric_vehicles', { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching vehicles:', error);
    throw error;
  }
};

export const getVehiclesByUserAndPlace = async (params) => {
  try {
    const response = await api.get('/electric_vehicles/by_user_and_place', { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching vehicles by user and place:', error);
    throw error;
  }
};

export const createVehicle = async (vehicleData) => {
  try {
    const response = await api.post('/electric_vehicles', vehicleData);
    return response.data;
  } catch (error) {
    console.error('Error creating vehicle:', error);
    throw error;
  }
};

export const updateVehicle = async (id, vehicleData) => {
  try {
    const response = await api.put(`/electric_vehicles/${id}`, vehicleData);
    return response.data;
  } catch (error) {
    console.error(`Error updating vehicle ${id}:`, error);
    throw error;
  }
};

export const getVehiclesByPlateLike = async (plateLike, params) => {
  try {
    const response = await api.get(`/electric_vehicles/by_plate_like/${plateLike}`, { params });
    return response.data;
  } catch (error) {
    console.error(`Error fetching vehicles by plate like ${plateLike}:`, error);
    throw error;
  }
};

export const deleteVehicle = async (id) => {
  try {
    const response = await api.delete(`/electric_vehicles/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error deleting vehicle ${id}:`, error);
    throw error;
  }
};

